import React from 'react';
import { useTranslation } from 'react-i18next';

import './steps.scss';

export enum ESteps {
  WaitingForTransaction = 'STEP.WAITING_FOR_TRANSACTION',
  TransactionDetected = 'STEP.TRANSACTION_DETECTED',
  TransactionPartiallyConfirmed = 'STEP.TRANSACTION_PARTIALLY_CONFIRMED',
  TransactionCompleted = 'STEP.TRANSACTION_COMPLETED',
}

interface IPropsSteps {
  stepNumber?: any;
  isComplete: boolean;
}

const Steps: React.FC<IPropsSteps> = ({ stepNumber, isComplete }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ul className="steps">
      {Object.values(ESteps).map((step) => {
        let isCheck: boolean | null = null;

        if (step === ESteps.WaitingForTransaction) isCheck = stepNumber >= 0;
        if (step === ESteps.TransactionDetected) isCheck = stepNumber >= 0;
        if (step === ESteps.TransactionPartiallyConfirmed) isCheck = stepNumber >= 1 || isComplete;
        if (step === ESteps.TransactionCompleted) isCheck = isComplete;

        return (
          <li
            className={`steps-item ${isCheck ? 'active' : 'wait'}`}
            key={step}
          >
            <p className="point" />
            <p className="name">{t(step)}</p>
          </li>
        );
      })}
    </ul>
  );
};

export default Steps;
